<template>
	<section class="booking-calendar-month padding-bottom-xs-2">
		<BookingCalendarMonthDesktopHeader />
		<div class="booking-calendar-month-outer-wrapper">
			<div class="booking-calendar-month-calendar">
				<div class="booking-calendar-month-calendar-header">
					<div class="booking-calendar-month-calendar-header-item">
						<p>
							<strong></strong>
						</p>
					</div>
					<div class="booking-calendar-month-calendar-header-item">
						<p><strong>Mån</strong></p>
					</div>
					<div class="booking-calendar-month-calendar-header-item">
						<p><strong>Tis</strong></p>
					</div>
					<div class="booking-calendar-month-calendar-header-item">
						<p><strong>Ons</strong></p>
					</div>
					<div class="booking-calendar-month-calendar-header-item">
						<p><strong>Tor</strong></p>
					</div>
					<div class="booking-calendar-month-calendar-header-item">
						<p><strong>Fre</strong></p>
					</div>
					<div
						class="booking-calendar-month-calendar-header-item booking-calendar-month-calendar-header-item-saturday"
					>
						<p><strong>Lör</strong></p>
					</div>
					<div
						class="booking-calendar-month-calendar-header-item booking-calendar-month-calendar-header-item-weekday-7"
					>
						<p><strong>Sön</strong></p>
					</div>
				</div>
			</div>
			<div class="booking-calendar-inner-wrapper">
				<div class="booking-calendar-months-weeks-wrapper">
					<div
						class="booking-calendar-months-dates-item"
						v-for="week in weeks"
						:class="{ 'current-week': isCurrentWeek(week) }"
						:key="'week-' + week"
					>
						<strong><span class="">v. </span>{{ week }}</strong>
					</div>
				</div>
				<div class="booking-calendar-months-dates-wrapper">
					<div
						v-if="ui.loading.times"
						class="calendar-loading-spinner"
					>
						<img
							class="loading-spinner"
							src="/wp-content/themes/nordiskakliniken/dist/images/loading-spinner.svg"
						/>
					</div>
					<div
						v-for="date in dates.active.monthDates"
						:key="'month-calendar-' + date.niceDate"
						class="booking-calendar-months-dates-item"
						:class="getWeekDayClassesByDate(date)"
					>
						<span
							class="date-number"
							v-if="
								!dateHasSlot(date.niceDate) || ui.loading.times
							"
							v-html="date.dayOfMonth"
						></span>
						<a
							href="#"
							class="booking-calendar-months-dates-item-slot"
							v-if="
								dateHasSlot(date.niceDate) && !ui.loading.times
							"
							@click.prevent="
								handleClickOnMonthCalendarSlot(date)
							"
						>
							<span
								class="date-number"
								v-html="date.dayOfMonth"
							></span>
						</a>
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import moment from "moment";
import { mapState, mapActions } from "vuex";
import BookingCalendarMonthDesktopHeader from "./BookingCalendarMonthDesktopHeader.vue";
export default {
	computed: {
		...mapState(["dates", "availableTimes", "ui", "providers"]),
		/* Calculate how many empty dates to insert into the calendar before the first day of the month */
		weeks() {
			let weeks = [];
			for (let i in this.dates.active.monthDates) {
				let date = this.dates.active.monthDates[i];
				if (!weeks.includes(date.weekOfYear)) {
					weeks.push(date.weekOfYear);
				}
			}
			return weeks;
		},
	},
	methods: {
		...mapActions(["handleClickOnMonthCalendarSlot"]),
		isCurrentWeek(week) {
			if (this.dates.current.week == week) {
				return true;
			}
			return false;
		},
		getWeekDayClassesByDate(date) {
			var classes = "";
			classes +=
				"booking-calendar-month-calendar-header-item-weekday-" +
				date.dayOfWeek +
				" ";
			if (!this.dateHasSlot(date.niceDate) && !this.ui.loading.times) {
				classes += "no-slots";
			}
			return classes;
		},
		dateHasSlot(date) {
			for (let i in this.availableTimes) {
				let slot = this.availableTimes[i];
				if (slot.terapeut_id == 8) {
					//continue;
				}
				if (slot.date == date) {
					/* If no provider is selected, and the date is available, return true */
					if (!this.providers.selected) {
						return true;
					}
					/* Otherwise, check if the provider has a slot this day */
					if (this.providers.selected) {
						if (this.providers.selected == slot.terapeut_sign) {
							return true;
						}
					}
				}
			}
			return false;
		},
	},
	components: { BookingCalendarMonthDesktopHeader },
};
</script>